import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ApiService } from '../../../services/api/api.service';

const name = 'DASHBOARD_DISCOUNT';

export const postDiscounts = createAsyncThunk(`${name}/POST_DISCOUNTS`,
  async ({vendorId, discountsModel}, thunkApi) => {
    try {
      const response = await ApiService.post(`/vendor/admin/${vendorId}/discounts`, discountsModel);
      let data = await response.data;
      if (response.status === 200) {
        return data;
      }
      return thunkApi.rejectWithValue(data);
    } catch (e) {
      return thunkApi.rejectWithValue(e);
    }
  });

export const getDiscounts = createAsyncThunk(`${name}/GET_DISCOUNTS`,
  async ({vendorId}, thunkApi) => {
    try {
      const response = await ApiService.get(`/vendor/admin/${vendorId}/discounts`);
      let data = await response.data;
      if (response.status === 200) {
        return data;
      }
      return thunkApi.rejectWithValue(data);
    } catch (e) {
      return thunkApi.rejectWithValue(e);
    }
  });

export const getCategories = createAsyncThunk(`${name}/GET_CATEGORIES`,
  async ({}, thunkApi) => {
    try {
      const response = await ApiService.get('/event/categories');
      let data = await response.data;
      if (response.status === 200) {
        return data;
      }
      return thunkApi.rejectWithValue(data);
    } catch (e) {
      return thunkApi.rejectWithValue(e);
    }
  });

const initialState = {
  discounts: [],
  categories: [],
  isFetching: false,
  isFetched: false,
  isError: false,
  errorMessage: '',
};

export const dashboardDiscountSlice = createSlice({
  name,
  initialState: initialState,
  extraReducers: {
    [getDiscounts.fulfilled]: (state, { payload }) => {
      state.discounts = payload;
      state.isFetching = false;
      state.isFetched = true;
      return state;
    },
    [getDiscounts.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      state.errorMessage = payload?.message || '';
    },
    [getDiscounts.pending]: (state) => {
      state.isFetching = true;
    },
    [getCategories.fulfilled]: (state, { payload }) => {
      state.categories = payload;
      state.isFetching = false;
      state.isFetched = true;
      return state;
    },
    [getCategories.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      state.errorMessage = payload?.message || '';
    },
    [getCategories.pending]: (state) => {
      state.isFetching = true;
    },
  }
});

//return categories in object where (key === id of category)
export const getFlatCategories = state => {
  const _obj = {};
  state.categories.map( e => {
    _obj[e.id] = {...e};
    e.categories.map( i => {
      _obj[i.id] = {...i, parentId: e.id};
    });
  });
  return _obj;
};

//return discounts in object where (key === id of category)
export const getFlatDiscounts = state => {
  return {...state.discounts.categories, ...state.discounts.types, ...state.discounts.general, ...state.discounts['all-friends-here']
  };
};

export const getIsDataFetched = state => {
  return state.discounts?.categories !== undefined && state.categories.length > 0;
};
